import { PoisApi } from '@linktivity/tata';
import config from '../config';

const poisApi = new PoisApi(config);

export default poisApi;
